module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floorplan"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/alaprajzok2.jpg"),
      "usemap": "#image-map"
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "image-map",
      "id": "image-map"
    }
  }, [_c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "96,501,207,573",
      "shape": "rect"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 1)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "260,480,348,551",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 2)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "353,481,440,547",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 3)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "416,208,485,357",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 4)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "492,184,556,246",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 5)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "556,317,490,258",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 6)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "492,330,556,394",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 7)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "629,179,703,242",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 8)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "622,258,701,319",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 9)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "622,328,701,391",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 10)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "704,486,735,552",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 12)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "994,430,1023,491",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 13)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1111,308,1165,349",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 16)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1327,200,1440,333",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 18)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1240,375,1325,459",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 19)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1457,308,1523,351",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 20)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1623,423,1683,454",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 22)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1361,399,1428,441",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 23)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1034,741,1166,816",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 24)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1173,741,1247,818",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 25)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1255,742,1330,815",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 26)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1346,737,1433,820",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 27)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1082,855,1166,916",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 28)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1176,850,1232,919",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 29)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1276,852,1332,924",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 30)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1345,850,1396,921",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 31)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1503,908,1586,989",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 32)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1588,910,1668,987",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 33)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "1673,908,1733,985",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 34)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "279,1127,348,1175",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 35)
      }
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "target": "",
      "alt": "",
      "title": "",
      "href": "#",
      "coords": "421,1029,489,1077",
      "shape": "0"
    },
    on: {
      "click": function($event) {
        _vm.areaSelected($event, 36)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tooltip",
    attrs: {
      "id": "tooltip"
    }
  }, [(_vm.selectedSponsor) ? _c('div', [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedSponsor.company) + "\n\t\t\t"), _c('a', {
    attrs: {
      "href": _vm.selectedSponsor.website
    }
  }, [_c('span', {
    staticClass: "picker-button"
  }, [_vm._v("Weboldal megnyitása")])])]) : _c('div', [_vm._v("\n\t\t\tNincs kiállító\n\t\t")]), _vm._v(" "), _c('i', {
    staticClass: "arrow down"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd0e46ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/floorplan.vue
// module id = 560
// module chunks = 2